import { callApi } from "./api.service";
import { ApiResponse } from "../models/api-response";

const API_URL = import.meta.env.VITE_API_SERVER_URL;

export interface Tenant {
  id: string;
  name: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export interface TenantsResponse {
  tenants: Tenant[];
}

export const getTenants = async (token: string): Promise<ApiResponse<TenantsResponse>> => {
  return callApi<TenantsResponse>(`${API_URL}/api/tenants`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createTenant = async (
  token: string,
  name: string
): Promise<ApiResponse<Tenant>> => {
  return callApi<Tenant>(`${API_URL}/api/tenants`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ name }),
  });
};

